module.exports = {"api":"https://api.mediamarkt.count3r.nl"}


//////////////////
// WEBPACK FOOTER
// ./env.json
// module id = 245
// module chunks = 0